export const getStepStatus = (index, current) => {
  if (index < current) return 'completed';
  if (index === current) return 'active';
  return 'pending';
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Steps/utils/stepsHelpers.js